<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div
  class="container-header pc-page"
  [class.pc-page--kanban]="activeTab === 'kanban'"
  [class.pc-page--lista]="activeTab === 'lista'"
  [class.pc-page--conteudo-scroll]="conteudoViewportAtivo">

  <!-- ===== PAGE HEADER ===== -->
  <div class="container-header-inner-list pc-page-top">

    <!-- Title row -->
    <div class="row mb-4 pc-page-top__collapsible">
      <div class="col-md-6">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Kanban de Compras</h1>
            <p class="welcome-message">Fluxo de solicitações, cotações, pedidos e recebimento</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 header-actions">
        <!-- acoesLoading = cancelamento em andamento (lote ou linha): spinner no próprio botão. -->
        <button mat-stroked-button class="btn-secondary btn-spinner" [class.btn-loading]="acoesLoading"
          [matMenuTriggerFor]="acoesMenu" [disabled]="acoesLoading"
          [attr.aria-label]="acoesLoading ? 'Cancelando compras' : null">
          Ações{{ temSelecionados ? ' (' + listSelection.selected.length + ')' : '' }}
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
          @if (acoesLoading) { <mat-spinner diameter="20"></mat-spinner> }
        </button>

        <mat-menu #acoesMenu="matMenu">
          @if (temSelecionados) {
            <button mat-menu-item (click)="exportarSelecionadas()">
              <mat-icon class="material-symbols-outlined">file_upload</mat-icon>
              <span>Exportar selecionadas para planilha</span>
            </button>
            <mat-divider></mat-divider>
            <span [matTooltip]="semPermissaoCancelarCompra" [matTooltipDisabled]="podeCancelarCompra">
              <button mat-menu-item (click)="cancelarSelecionadas()" [disabled]="!podeCancelarCompra">
                <mat-icon class="material-symbols-outlined">block</mat-icon>
                <span>Cancelar compras</span>
              </button>
            </span>
          } @else {
            <button mat-menu-item (click)="exportarLista()">
              <mat-icon class="material-symbols-outlined">file_upload</mat-icon>
              <span>Exportar lista para planilha</span>
            </button>
          }
        </mat-menu>

        <button mat-stroked-button type="button" class="btn-secondary pc-btn-gaveta"
          [matBadge]="gavetaTotal"
          [matBadgeHidden]="gavetaTotal === 0"
          (click)="abrirGaveta()">
          <mat-icon class="material-symbols-outlined">inbox</mat-icon>
          Gaveta de NFs
        </button>

        <button mat-flat-button class="btn-primary" (click)="openNovasolicitacao()">
          <mat-icon class="material-symbols-outlined">add</mat-icon>
          Nova solicitação
        </button>
      </div>
    </div>

    <!-- Search + filter row -->
    <div class="row search-area g-3 pc-page-top__collapsible" [formGroup]="filterModel">
      <div class="col-xl-8 col-lg-8 col-12">
        <mat-form-field appearance="outline" class="filter-pesquisa" subscriptSizing="dynamic">
          <mat-label>Pesquisar</mat-label>
          <input matInput placeholder="Buscar por # ou título…" formControlName="searchText" />
          <button mat-icon-button matSuffix type="button">
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div class="col-xl-4 col-lg-4 col-12">
        <div class="filter-actions">
          <button mat-stroked-button type="button" class="btn-filter"
            [matBadge]="qtdFiltrosAvancados"
            [matBadgeHidden]="qtdFiltrosAvancados === 0"
            [matMenuTriggerFor]="filtroMenu">
            <mat-icon class="material-symbols-outlined">filter_list</mat-icon>
            Filtrar
          </button>

          <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
            <div class="filter-menu-content" [formGroup]="filterModel">
              <div (click)="$event.stopPropagation()">
                <h6>Filtros</h6>
                <div class="filter-menu__form">
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Responsável</mat-label>
                    <mat-select formControlName="filterRespId">
                      <mat-option [value]="null">Todos</mat-option>
                      @for (p of peopleList; track p.idUsuario) {
                        <mat-option [value]="p.idUsuario">{{ p.name }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Prioridade</mat-label>
                    <mat-select formControlName="filterPrio">
                      <mat-option value="">Todas</mat-option>
                      <mat-option value="alta">Alta</mat-option>
                      <mat-option value="media">Média</mat-option>
                      <mat-option value="baixa">Baixa</mat-option>
                    </mat-select>
                  </mat-form-field>
                  @if (activeTab === 'lista') {
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                      <mat-label>Etapa</mat-label>
                      <mat-select formControlName="filterStage">
                        <mat-option value="">Todas</mat-option>
                        @for (s of allStages; track s.key) {
                          <mat-option [value]="s.key">{{ s.name }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="filterStatus">
                      <mat-option value="">Todos</mat-option>
                      @for (s of statusFiltroOpcoes; track s.value) {
                        <mat-option [value]="s.value">{{ s.label }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="filter-menu__actions">
                <button mat-button class="btn-secondary" matMenuClose>Cancelar</button>
                <button mat-flat-button class="btn-primary" (click)="aplicarFiltros()" matMenuClose>Aplicar</button>
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
            <mat-icon>cleaning_services</mat-icon>
            Limpar Filtros
          </button>
        </div>
      </div>
    </div>

    <!-- Tab bar -->
    <div class="pc-tabs-bar">
      <button #tabBtnKanban class="pc-tab" [class.pc-tab--active]="activeTab === 'kanban'" (click)="selecionarAba('kanban')">
        <mat-icon class="material-symbols-outlined">view_kanban</mat-icon>
        Kanban
      </button>
      <button #tabBtnLista class="pc-tab" [class.pc-tab--active]="activeTab === 'lista'" (click)="selecionarAba('lista')">
        <mat-icon class="material-symbols-outlined">list</mat-icon>
        Lista
      </button>
      <span class="pc-tab-indicator"
        [style.transform]="'translateX(' + indicadorX + 'px)'"
        [style.width.px]="indicadorW"></span>
      <span class="pc-tab-spacer"></span>
      <span class="pc-tab-count">
        <b>{{ totalCardsVisiveis }}</b> {{ totalCardsVisiveis === 1 ? ' compra' : ' compras' }}
      </span>
    </div>
  </div>

  <!-- ===== KANBAN BOARD ===== -->
  @if (activeTab === 'kanban') {
    <div #boardWrapper class="pc-board-wrapper">
      <!-- #boardEl recebe o preview do arraste: fora da coluna (que pode estar com opacidade reduzida
           por bloqueio) e dentro do host, para herdar as variáveis de cor e o modo escuro. -->
      <div class="pc-board" #boardEl [class.pc-board--no-card-animation]="suppressCardMoveAnimation" cdkDropListGroup>

        <!-- Card fantasma, usado tanto nas colunas reais quanto nas colunas fantasma. -->
        <ng-template #cardSkeleton>
          <div class="pc-card pc-card--skeleton" aria-hidden="true">
            <div class="pc-card-top">
              <app-loading-box height="10" width="72"></app-loading-box>
              <app-loading-box height="8" width="8"></app-loading-box>
            </div>
            <app-loading-box height="12" width="110" margin="0 0 8px 0"></app-loading-box>
            <app-loading-box height="10" width="110" margin="0 0 12px 0"></app-loading-box>
            <div class="pc-card-footer">
              <app-loading-box height="22" width="22"></app-loading-box>
              <app-loading-box height="9" width="62"></app-loading-box>
            </div>
          </div>
        </ng-template>

        <ng-template #colColapsada let-stage>
          <div
            class="pc-col-collapsed"
            [class.pc-col-collapsed--no-access]="stage.podeVisualizar === false"
            [class.pc-col-collapsed--blocked]="isDropBlocked(stage.key)"
            [style.border-top-color]="stage.color"
            cdkDropList
            [cdkDropListData]="cardsByStage[stage.key]"
            [cdkDropListSortingDisabled]="true"
            [id]="'drop-' + stage.key"
            (cdkDropListDropped)="drop($event, stage.key)"
            (click)="toggleCollapsedStage(stage)"
            [matTooltip]="getCollapsedStageTooltip(stage)">
            <span class="pc-col-icon" [style.border-color]="stage.color" [style.background]="stage.tint" [style.color]="stage.color">
              <mat-icon class="material-symbols-outlined">{{ stage.icon }}</mat-icon>
            </span>
            <span class="pc-col-badge">{{ totalDaEtapa(stage.key) }}</span>
            <div class="pc-col-name-vertical">{{ stage.name }}</div>
            <mat-icon class="material-symbols-outlined pc-icon-muted pc-col-expandir">keyboard_double_arrow_right</mat-icon>
          </div>
        </ng-template>

        <ng-template #colExpandida let-stage>
          <div
            class="pc-column"
            [class.pc-column--blocked]="isDropBlocked(stage.key)"
            [class.pc-column--slot-topo]="etapaSlotTopo === stage.key"
            cdkDropList
            [cdkDropListData]="cardsByStage[stage.key]"
            [cdkDropListSortingDisabled]="isEtapaAgrupadaPorNf(stage.key)"
            [id]="'drop-' + stage.key"
            (cdkDropListDropped)="drop($event, stage.key)"
            (cdkDropListEntered)="entrouNaEtapa(stage.key)"
            (cdkDropListExited)="etapaSlotTopo = null">

            <div class="pc-col-accent" [style.background]="stage.color"></div>

            <div class="pc-col-header">
              <span class="pc-col-icon" [style.border-color]="stage.color" [style.background]="stage.tint" [style.color]="stage.color">
                <mat-icon class="material-symbols-outlined">{{ stage.icon }}</mat-icon>
              </span>
              <div class="pc-col-header-info">
                <div class="pc-col-name">{{ stage.name }}</div>
                <div class="pc-col-total">{{ cardValueLabel(getColumnTotal(stage.key)) }}</div>
              </div>
              <span class="pc-col-badge">{{ totalDaEtapa(stage.key) }}</span>
              <button class="pc-icon-btn" (click)="toggleCollapse(stage.key)" matTooltip="Recolher">
                <mat-icon class="material-symbols-outlined">keyboard_double_arrow_left</mat-icon>
              </button>
            </div>

            @if (isDropBlocked(stage.key)) {
              <div class="pc-blocked-overlay">
                <span class="pc-blocked-badge">
                  <mat-icon class="material-symbols-outlined">block</mat-icon>
                  Movimento não permitido
                </span>
              </div>
            }

            <!-- Conteúdo do card do quadro, compartilhado pelo card solto (arrastável) e pelo card dentro
                 da moldura da NF (quem arrasta é a moldura). -->
            <ng-template #cardConteudo let-card>
                  <div class="pc-card-top">
                    <span class="pc-card-subtitulo" [attr.title]="card.title || null">{{ card.title }}</span>
                    <span class="pc-prio-dot" [style.background]="getPrioColor(card.prio)" [matTooltip]="prioConfig[card.prio]?.label"></span>
                  </div>
                  <div class="pc-card-title">{{ getCardTitle(card) }}</div>
                  @if (nomeFornecedor(card); as fornecedor) {
                    <div class="pc-card-vendor">
                      <mat-icon class="material-symbols-outlined">storefront</mat-icon>
                      <span [attr.title]="fornecedor">{{ fornecedor }}</span>
                      @if ((card.qtdFornecedores ?? 0) > 1) {
                        <span class="pc-card-vendor-mais">+{{ (card.qtdFornecedores ?? 0) - 1 }}</span>
                      }
                    </div>
                  }
                  @if (card.stage === 'cotacao' && (card.qtdFornecedores ?? 0) > 0) {
                    <span class="status-badge pc-card-aprovacao"
                      [class.badge-verde]="(card.qtdFornecedoresResponderam ?? 0) > 0"
                      [class.badge-amarelo]="!card.qtdFornecedoresResponderam">
                      <mat-icon class="material-symbols-outlined">mark_email_read</mat-icon>
                      {{ card.qtdFornecedoresResponderam ?? 0 }} de {{ card.qtdFornecedores }} respondeu
                    </span>
                  }
                  <!-- Aprovação: situação só na etapa Aprovação; nas seguintes o pedido já está aprovado. -->
                  @if (card.stage === 'aprovacao') {
                    <span class="status-badge pc-card-aprovacao"
                      [class.badge-verde]="card.isAprovado" [class.badge-amarelo]="!card.isAprovado">
                      <mat-icon class="material-symbols-outlined">{{ card.isAprovado ? 'check_circle' : 'schedule' }}</mat-icon>
                      {{ card.isAprovado ? 'Aprovado' : 'Aguardando aprovação' }}
                    </span>
                  }
                  <!-- Integrações lançadas pela própria compra (E, F), na cor da sigla; sem letra quando não lançado. -->
                  @if (integracoes(card).length) {
                    <span class="indicador-grid pc-card-integracoes">
                      @for (integracao of integracoes(card); track integracao.sigla) {
                        <span class="indicador indicador-sm" [style.--indicador-cor]="integracao.cor"
                          [matTooltip]="integracao.rotulo" [attr.aria-label]="integracao.rotulo">{{ integracao.sigla }}</span>
                      }
                    </span>
                  }
                  <!-- Pedido marcado sem nota fiscal no card. -->
                  @if (card.isSemNotaFiscal) {
                    <span class="status-badge pc-card-aprovacao badge-cinza">
                      <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
                      Sem NF
                    </span>
                  }
                  <!-- Conferência física: pílula de problema, barra (volumes, itens) e resumo; olho riscado no modo cego. -->
                  @if (temProgressoConferencia(card)) {
                    <div class="pc-card-conf">
                      @if ((card.quantidadeProblemasConferencia ?? 0) > 0) {
                        <span class="status-badge badge-vermelho pc-card-aprovacao">
                          <mat-icon class="material-symbols-outlined">error</mat-icon>
                          Divergência pendente
                        </span>
                      }
                      @if ((card.quantidadeDivergenciasConferencia ?? 0) > 0) {
                        <span class="status-badge badge-vermelho pc-card-aprovacao">
                          <mat-icon class="material-symbols-outlined">error</mat-icon>
                          {{ card.quantidadeDivergenciasConferencia }} {{ card.quantidadeDivergenciasConferencia === 1 ? 'divergência' : 'divergências' }}
                        </span>
                      }
                      <div class="pc-card-conf-passos">
                        @for (classePasso of passosConferencia(card); track $index) {
                          <span class="pc-card-conf-passo" [ngClass]="classePasso"></span>
                        }
                      </div>
                      <div class="pc-card-conf-resumo">
                        @if (isConferenciaCega(card)) {
                          <mat-icon class="material-symbols-outlined" matTooltip="Modo cego">visibility_off</mat-icon>
                        }
                        <span>{{ resumoConferencia(card) }}</span>
                      </div>
                    </div>
                  }
                  <div class="pc-card-value">{{ cardValueLabel(card.value) }}</div>
                  <div class="pc-card-footer">
                    <span class="pc-avatar" [style.background]="getPerson(card.resp, card.respName, card.respColor).color" [matTooltip]="getPerson(card.resp, card.respName, card.respColor).name">
                      {{ card.resp }}
                    </span>
                    <span class="pc-card-date">
                      <mat-icon class="material-symbols-outlined">event</mat-icon>
                      {{ card.date }}
                    </span>
                  </div>
                  @if (isCardLoading(card)) {
                    <div class="pc-card-loading" aria-label="Carregando detalhes">
                      <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
                    </div>
                  }
            </ng-template>

            <!-- Card solto: o próprio card é o cdkDrag. Declarado dentro do cdkDropList para o cdkDrag
                 enxergar a coluna por DI. -->
            <ng-template #cardTpl let-card>
              <div
                class="pc-card"
                [class.pc-card--loading]="isCardLoading(card)"
                cdkDrag
                [cdkDragData]="card"
                [cdkDragDisabled]="hasActiveFilters"
                [matTooltip]="motivoArrasteBloqueado"
                [matTooltipDisabled]="!hasActiveFilters"
                [cdkDragPreviewContainer]="boardEl"
                (cdkDragStarted)="dragStarted(card, $event)"
                (cdkDragEnded)="dragEnded()"
                (click)="openCard(card)">
                <ng-container [ngTemplateOutlet]="cardConteudo" [ngTemplateOutletContext]="{ $implicit: card }"></ng-container>
              </div>
            </ng-template>

            <!-- Card dentro da moldura da NF: sem cdkDrag próprio, o arraste é da moldura inteira. Abre no
                 modo NF pela nota da moldura, com este pedido selecionado. -->
            <ng-template #cardNaMoldura let-card let-grupo="grupo">
              <div class="pc-card" [class.pc-card--loading]="isCardLoading(card)" (click)="abrirNota(grupo, card)">
                <ng-container [ngTemplateOutlet]="cardConteudo" [ngTemplateOutletContext]="{ $implicit: card }"></ng-container>
              </div>
            </ng-template>

            <div class="pc-cards-area">
              <!-- Nas etapas com NF o card entra no topo, fora das notas: o espaço do CDK (antes do card
                   sob o ponteiro, que pode estar numa moldura) fica oculto e este marca o lugar real. -->
              @if (etapaSlotTopo === stage.key) {
                <div class="pc-drop-slot" [style.height.px]="alturaCardArrastado"></div>
              }
              @for (grupo of gruposDaEtapa(stage.key); track grupo.chave) {
                @if (grupo.isGrupo) {
                  <!-- A moldura inteira é o cdkDrag: agarrando o cabeçalho ou um pedido, a NF vai junto no
                       preview. O pedido agarrado é resolvido no dragStarted (Cancelar continua individual). -->
                  <div
                    class="pc-nf-grupo"
                    cdkDrag
                    [cdkDragData]="grupo.cards[0]"
                    [cdkDragDisabled]="hasActiveFilters"
                    [cdkDragPreviewContainer]="boardEl"
                    (cdkDragStarted)="dragStarted(grupo.cards[0], $event, grupo)"
                    (cdkDragEnded)="dragEnded()">
                    <!-- Cabeçalho clicável abre o card do primeiro pedido no modo NF (nota, pedidos e itens);
                         arrastar continua pela moldura inteira. -->
                    <div class="pc-nf-grupo-header" role="button" tabindex="0" aria-label="Abrir nota"
                      (click)="abrirNota(grupo)" (keydown.enter)="abrirNota(grupo)">
                      <mat-icon class="material-symbols-outlined pc-nf-grupo-icone">receipt_long</mat-icon>
                      <!-- Tooltip do arraste desligado no texto e nos pedidos, não na moldura: o botão de
                           vínculo tem tooltip próprio e os dois não podem abrir juntos. -->
                      <div class="pc-nf-grupo-info"
                        [matTooltip]="motivoArrasteBloqueado" [matTooltipDisabled]="!hasActiveFilters">
                        <div class="pc-nf-grupo-titulo">{{ grupo.rotulo }}</div>
                        <div class="pc-nf-grupo-subtitulo">{{ grupo.pedidosLabel }} · {{ grupo.totalLabel }}</div>
                      </div>
                      <!-- Tooltip no span: botão nativo desabilitado não dispara eventos de mouse. O clique no
                           span não abre a nota. -->
                      <span [matTooltip]="podeGerenciarVinculoNota ? 'Gerenciar vínculo da nota' : semPermissaoGerenciarVinculo"
                        (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()">
                        <button type="button" class="pc-nf-grupo-btn btn-spinner"
                          [class.btn-loading]="gerenciandoNotaId === grupo.idNFeEntrada"
                          [disabled]="!podeGerenciarVinculoNota || gerenciandoNotaId !== null"
                          aria-label="Gerenciar vínculo da nota"
                          (click)="$event.stopPropagation(); gerenciarVinculoNota(grupo.idNFeEntrada)">
                          <mat-icon class="material-symbols-outlined">tune</mat-icon>
                          @if (gerenciandoNotaId === grupo.idNFeEntrada) { <mat-spinner diameter="16"></mat-spinner> }
                        </button>
                      </span>
                    </div>
                    <div class="pc-nf-grupo-cards"
                      [matTooltip]="motivoArrasteBloqueado" [matTooltipDisabled]="!hasActiveFilters">
                      @for (card of grupo.cards; track card.renderKey || card.id) {
                        <ng-container [ngTemplateOutlet]="cardNaMoldura" [ngTemplateOutletContext]="{ $implicit: card, grupo: grupo }"></ng-container>
                      }
                    </div>
                  </div>
                } @else {
                  @for (card of grupo.cards; track card.renderKey || card.id) {
                    <ng-container [ngTemplateOutlet]="cardTpl" [ngTemplateOutletContext]="{ $implicit: card }"></ng-container>
                  }
                }
              }

              @if (etapaEstado(stage.key).carregando) {
                @for (slot of skeletonCards; track slot) {
                  <ng-container [ngTemplateOutlet]="cardSkeleton"></ng-container>
                }
              } @else if (etapaEstado(stage.key).temMais) {
                <button mat-button type="button" class="btn-ver-mais pc-col-ver-mais"
                  (click)="carregarMaisDaEtapa(stage.key)">
                  <span class="material-symbols-outlined">expand_more</span> Ver Mais
                </button>
              }
            </div>
          </div>
        </ng-template>

        @if (etapasCarregando) {
          <!-- Sem etapa carregada não existe coluna para preencher: o quadro inteiro é fantasma. -->
          @for (col of skeletonColumns; track col) {
            <div class="pc-column pc-column--skeleton" aria-hidden="true">
              <div class="pc-col-accent pc-col-accent--skeleton"></div>
              <div class="pc-col-header">
                <app-loading-box height="28" width="28"></app-loading-box>
                <div class="pc-col-header-info">
                  <app-loading-box height="11" width="96" margin="0 0 5px 0"></app-loading-box>
                  <app-loading-box height="9" width="62"></app-loading-box>
                </div>
                <app-loading-box height="20" width="22"></app-loading-box>
              </div>
              <div class="pc-cards-area">
                @for (slot of skeletonCards; track slot) {
                  <ng-container [ngTemplateOutlet]="cardSkeleton"></ng-container>
                }
              </div>
            </div>
          }
        } @else {
          <!-- MAIN STAGES -->
          @for (stage of mainStages; track stage.key) {
            <ng-container
              [ngTemplateOutlet]="isCollapsed(stage.key) ? colColapsada : colExpandida"
              [ngTemplateOutletContext]="{ $implicit: stage }"></ng-container>
          }

          <!-- Divider -->
          <div class="pc-board-divider"></div>

          <!-- SIDE STAGES -->
          @for (stage of sideStages; track stage.key) {
            <ng-container
              [ngTemplateOutlet]="isCollapsed(stage.key) ? colColapsada : colExpandida"
              [ngTemplateOutletContext]="{ $implicit: stage }"></ng-container>
          }
        }

      </div>
    </div>
  }

  <!-- ===== LIST VIEW ===== -->
  @if (activeTab === 'lista') {
    <div class="pc-list-wrapper">
      @if (paginatedCards.length > 0) {
        <div class="pc-table-card desktop-view">
          <table mat-table [dataSource]="paginatedCards" matSort
            [matSortActive]="listSortActive" [matSortDirection]="listSortDirection"
            (matSortChange)="onListSortChange($event)">

            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef class="w-checkbox">
                <mat-checkbox (change)="$event ? toggleListAllRows() : null"
                  [checked]="listSelection.hasValue() && isListAllSelected()">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let card" class="w-checkbox">
                <mat-checkbox (click)="$event.stopPropagation()"
                  (change)="$event ? listSelection.toggle(card) : null"
                  [checked]="listSelection.isSelected(card)">
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:80px">#</th>
              <td mat-cell *matCellDef="let card" class="pc-td--id">{{ card.id }}</td>
            </ng-container>

            <ng-container matColumnDef="title">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Título</th>
              <td mat-cell *matCellDef="let card">
                <span class="pc-td-title">{{ card.title || '—' }}</span>
                @if (nomeFornecedor(card); as fornecedor) {
                  <span class="pc-td-vendor">{{ fornecedor }}</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="stage">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:210px">Etapa atual</th>
              <td mat-cell *matCellDef="let card">
                <span class="pc-stage-badge"
                  [style.color]="getStage(card.stage).color"
                  [style.background]="getStage(card.stage).tint"
                  [style.border-color]="getStage(card.stage).color + '33'">
                  <mat-icon class="material-symbols-outlined">{{ getStage(card.stage).icon }}</mat-icon>
                  {{ getStage(card.stage).name }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="resp">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:180px">Responsável</th>
              <td mat-cell *matCellDef="let card">
                <span class="pc-resp">
                  <span class="pc-avatar pc-avatar--sm" [style.background]="getPerson(card.resp, card.respName, card.respColor).color">{{ card.resp }}</span>
                  {{ getPerson(card.resp, card.respName, card.respColor).name }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="prio">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:120px">Prioridade</th>
              <td mat-cell *matCellDef="let card">
                <span class="pc-prio-cell">
                  <span class="pc-prio-dot" [style.background]="getPrioColor(card.prio)"></span>
                  {{ prioConfig[card.prio]?.label }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:130px">Criado em</th>
              <td mat-cell *matCellDef="let card" class="pc-td--muted">{{ card.date }}</td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="width:150px">Status</th>
              <td mat-cell *matCellDef="let card">
                <span class="pc-status-badge"
                  [style.background]="getStatusFor(card).bg"
                  [style.color]="getStatusFor(card).fg">
                  {{ getStatusFor(card).label }}
                </span>
              </td>
            </ng-container>

            <!-- Integrações lançadas pela própria compra (E, F), como na lista de NF-e de entrada. -->
            <ng-container matColumnDef="integracoes">
              <th mat-header-cell *matHeaderCellDef class="text-center" style="width:120px">Integrações</th>
              <td mat-cell *matCellDef="let card" class="text-center">
                @if (integracoes(card).length) {
                  <span class="indicador-grid">
                    @for (integracao of integracoes(card); track integracao.sigla) {
                      <span class="indicador indicador-sm" [style.--indicador-cor]="integracao.cor"
                        [matTooltip]="integracao.rotulo" [attr.aria-label]="integracao.rotulo">{{ integracao.sigla }}</span>
                    }
                  </span>
                } @else {
                  —
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="value">
              <th mat-header-cell *matHeaderCellDef class="text-end" style="width:140px">Valor (R$)</th>
              <td mat-cell *matCellDef="let card" class="pc-td--value text-end">{{ cardValueLabel(card.value) }}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
              <td mat-cell *matCellDef="let card" class="text-center w-actions">
                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações" (click)="$event.stopPropagation()">
                  <span class="material-symbols-outlined">more_horiz</span>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openCard(card)">
                    <span class="material-symbols-outlined">edit</span>
                    <span>Editar</span>
                  </button>
                  <!-- O tooltip fica no wrapper porque um mat-menu-item desabilitado não emite eventos de mouse. -->
                  <span [matTooltip]="motivoCancelamentoBloqueado(card)"
                    [matTooltipDisabled]="!isCancelamentoBloqueado(card)">
                    <button mat-menu-item (click)="cancelarCard(card)" [disabled]="isCancelamentoBloqueado(card)">
                      <span class="material-symbols-outlined" [class.text-danger]="!isCancelamentoBloqueado(card)">block</span>
                      <span>Cancelar compra</span>
                    </button>
                  </span>
                </mat-menu>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="listDisplayedColumns"></tr>
            <!-- Sem (click) na linha: abrir a compra é ação explícita do menu "Ações".
                 A linha continua servindo para seleção via checkbox. -->
            <tr mat-row *matRowDef="let card; columns: listDisplayedColumns"></tr>
          </table>
        </div>

        <!-- Modo card (abaixo de 992px): mesmas colunas e ações da tabela. -->
        <div class="mobile-view">
          @for (card of paginatedCards; track card.id) {
            <div class="card-mobile mb-3" [class.selected-card]="listSelection.isSelected(card)">
              <div class="card-header-mobile d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center gap-2">
                  <mat-checkbox (change)="$event ? listSelection.toggle(card) : null"
                    [checked]="listSelection.isSelected(card)">
                  </mat-checkbox>
                  <span class="text-bold">{{ card.id }} · {{ card.title || '—' }}</span>
                </div>
                <button mat-icon-button [matMenuTriggerFor]="menuMobile" aria-label="Ações">
                  <span class="material-symbols-outlined">more_horiz</span>
                </button>
                <mat-menu #menuMobile="matMenu">
                  <button mat-menu-item (click)="openCard(card)">
                    <span class="material-symbols-outlined">edit</span>
                    <span>Editar</span>
                  </button>
                  <span [matTooltip]="motivoCancelamentoBloqueado(card)"
                    [matTooltipDisabled]="!isCancelamentoBloqueado(card)">
                    <button mat-menu-item (click)="cancelarCard(card)" [disabled]="isCancelamentoBloqueado(card)">
                      <span class="material-symbols-outlined">block</span>
                      <span>Cancelar compra</span>
                    </button>
                  </span>
                </mat-menu>
              </div>
              <div class="card-body-mobile p-3">
                @if (nomeFornecedor(card); as fornecedor) {
                  <p class="mb-1"><strong>Fornecedor:</strong> {{ fornecedor }}</p>
                }
                <p class="mb-1">
                  <strong>Etapa atual:</strong>
                  <span class="pc-stage-badge ms-1"
                    [style.color]="getStage(card.stage).color"
                    [style.background]="getStage(card.stage).tint"
                    [style.border-color]="getStage(card.stage).color + '33'">
                    <mat-icon class="material-symbols-outlined">{{ getStage(card.stage).icon }}</mat-icon>
                    {{ getStage(card.stage).name }}
                  </span>
                </p>
                <p class="mb-1"><strong>Responsável:</strong> {{ getPerson(card.resp, card.respName, card.respColor).name }}</p>
                <p class="mb-1">
                  <strong>Prioridade:</strong>
                  <span class="pc-prio-cell ms-1">
                    <span class="pc-prio-dot" [style.background]="getPrioColor(card.prio)"></span>
                    {{ prioConfig[card.prio]?.label }}
                  </span>
                </p>
                <p class="mb-1"><strong>Criado em:</strong> {{ card.date }}</p>
                <p class="mb-2"><strong>Valor:</strong> {{ cardValueLabel(card.value) }}</p>
                <span class="pc-status-badge"
                  [style.background]="getStatusFor(card).bg"
                  [style.color]="getStatusFor(card).fg">
                  {{ getStatusFor(card).label }}
                </span>
              </div>
            </div>
          }
        </div>

        <div class="col-12 text-center mt-4 mb-5">
          <button mat-button class="btn-ver-mais btn-spinner" [class.btn-loading]="listaCarregando"
            [disabled]="listaUltimaPagina || listaCarregando" (click)="carregarMaisCards()">
            <span class="material-symbols-outlined">expand_more</span> Ver Mais
            @if (listaCarregando) { <mat-spinner diameter="20"></mat-spinner> }
          </button>
        </div>
      } @else if (listaCarregando) {
        <app-loading-box-default-list></app-loading-box-default-list>
      } @else {
        <app-empty-list [title]="'Nenhuma compra encontrada'"
          [subTitle]="'Tente alterar os filtros de busca'"></app-empty-list>
      }
    </div>
  }

</div>

<!-- Fica fora do .container-header para o painel não herdar o overflow do board. -->
<app-gaveta-nfs
  [aberta]="gavetaAberta"
  (fechar)="fecharGaveta()"
  (totalChange)="onGavetaTotalChange($event)"
  (vinculado)="onGavetaVinculado()">
</app-gaveta-nfs>
